// import api from '@/request/api';
export default {
    namespaced: true,
    state: {
        userInfo: {},
        returnSup: '',
        isLogin: false
    },
    mutations: {
        upDataUserInfo(state, params) {
            //更新用户信息
            state.userInfo = params
        },
        projectsReturnSup(state, params) {
            //更新用户信息
            state.returnSup = params
        },
        updateLoginStatus(state, params) {
            state.isLogin = params
        }
    },
    actions: {
        // requesyNewPeo({ commit }) {
        // 	//请求新手任务-完成状态
        // 	// context.commit('increment')
        // 	api.activity
        // 		.getnewgiftStatus({
        // 			activityid: 20,
        // 			platform: 'getactid20status',
        // 		})
        // 		.then(res => {
        // 			if (res.status == '1181000030') {
        // 				let arr1 = res.data.data;
        // 				if (arr1.isdeposit == 1 && arr1.isBindCellphone == 1 && arr1.isBindCard == 1) {
        // 					//完成状态
        // 					commit('upDatanoviceTaskStatus', 2);
        // 				} else {
        // 					commit('upDatanoviceTaskStatus', 1);
        // 				}
        // 				// if (arr1.includes(0)) {
        // 				// 	commit("upDatanoviceTaskStatus", 1);
        // 				// } else {
        // 				// 	commit("upDatanoviceTaskStatus", 2);
        // 				// }
        // 			}
        // 		});
        // },
    },
    getters: {
        userInfo: state => {
            return state.userInfo
        }
    }
}
